import { ClbModal } from "@celebration/react/ClbModal/ClbModal";
import { ModalProps as ClbModalProps } from "@celebration/react/ClbModal/ClbModal.types";

type ModalProps = Pick<
  ClbModalProps,
  | "title"
  | "description"
  | "open"
> & {
  onConfirm?: () => void,
  onCancel?: () => void,
};

const Confirmation: React.FC<ModalProps> = ({ onConfirm, onCancel, ...props }) => (
  <ClbModal
    itemsFooter={[
      {
        size: "sm",
        key: "button-confirm",
        label: "Confirmar",
        type: "button",
        buttonStyle: "primary",
        onClick: onConfirm,
      },
      {
        size: "sm",
        key: "button-cancel",
        label: "Cancelar",
        type: "button",
        buttonStyle: "secondary",
        onClick: onCancel,
      },
    ]}
    {...props}
    customBody={<></>}
    onClose={onCancel} />
);

export default {
  Confirmation,
};
export type { ModalProps };